export const enum FileDocumentTypes {
  ClientDocs = "ClientDocs",
  ContactDocs = "ContactDocs",
  SupplierDocs = "SupplierDocs",
  CaseFile = "CaseFile",
  UserImage = "UserImage",
  Posting = "Posting",
}
